export default "__VITE_ASSET__DsiKaao5__"